module.exports = __webpack_public_path__ + "img/small-3.cc642783.png";